import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/material`

    return {
        anvisaSubstanciaControleEspecial: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-anvisa-substancia-controle-especial?${urlUtil.serialize(queryParms)}`)
            },
        },
        autocomplete(queryParms = {}) {

            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        getEstoque(materialId, centroCustoId = null, excluirLotesVencidos = false) {

            let url = `${baseUrl}/estoque/${materialId}`

            if (centroCustoId) {

                url += `/${centroCustoId}`
            }

            if (excluirLotesVencidos) {

                url += '?excluir_lotes_vencidos=1'
            }

            return repository.get(url)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        editMaterialBnafar(materialId) {
            return repository.get(`${baseUrl}/${materialId}/material-bnafar`)
        },
        updateMaterialBnafar(materialId, params) {

            return repository.put(`${baseUrl}/${materialId}/material-bnafar`, params)
        },
        storeIntegracaoBnafarMedicamentos(materialId, params) {

            return repository.post(`${baseUrl}/${materialId}/integracao-bnafar-medicamentos`, params)
        },
    }
}